<template>
	<div class="box-page">
		<div class="col-12 pl-0 pr-0">
			<div class="col-12 pl-0 pr-0">
				<div class="col-12 bg-white rounded-cus cus-box-shadow">
					<div class="col-12 pt-3 pb-3 pl-2 pr-2 filter-title cursor-pointer" data-toggle="collapse" data-target="#filterNewMitra">
						<div class="col-6 pl-0 mt-auto mb-auto">
							<div class="col-12 pl-0 pr-0 font-size-10"><span class="mr-2"><i class="fas fa-filter"></i></span>Filter</div>
						</div>
					</div>
					<div id="filterNewMitra" class="collapse">
						<div class="col-12 pb-3 pl-2 pr-2 d-flex flex-wrap font-size-10">
							<div class="col-12 col-md-8 col-lg-2 pl-0 pr-0 pr-md-3 d-flex">
								<div class="col-12 pl-0 pr-0 pr-md-3 d-flex">
									<div class="col-12 pl-0 pr-0">
										<input v-model="nama.value" class="form-control form-control-sm box-blue rounded-cus font-size-9 font-size-sm-8" type="text" placeholder="Nama Mitra">
									</div>
								</div>
							</div>
							<div class="col-12 col-md-8 col-lg-5 pl-0 pr-0 pr-md-3 pt-2 pt-lg-0 d-flex">
								<div class="col-4 pl-0 pr-0 pt-1 font-size-sm-9 d-none d-md-block">Tanggal Transaksi</div>
								<div class="col-12 col-md-8 pl-0 pr-0 pr-md-3 d-flex">
									<div class="col-6 pl-0 pr-2">
										<datetime  input-id="tanggalAwal" class="theme-purple h-100" input-class="col-12 pt-1 pb-1 border rounded-cus color-black box-purple font-size-9 font-size-sm-8" placeholder="Dari Tanggal" :max-datetime="maxDate" :min-datetime="new Date('2000-01-01').toISOString()" v-model="tanggalAwal"></datetime>
									</div>
									<div class="col-6 pl-0 pr-0">
										<datetime input-id="tanggalAkhir" class="theme-purple" input-class="col-12 pt-1 pb-1 border rounded-cus color-black box-purple font-size-9 font-size-sm-8" placeholder="Sampai Tanggal" :max-datetime="today" :min-datetime="minDate" v-model="tanggalAkhir"></datetime>
									</div>
								</div>
							</div>
							<div class="col-12 col-md-8 col-lg-2 pl-0 pr-0 pr-md-3 pt-2 pt-lg-0">
								<v-select v-model="pilihanSerial" label="text" class="font-size-9 font-size-sm-8 pr-md-3" :options="status" placeholder="Status Mitra">
								</v-select>
							</div>
							<div class="col-12 col-md-4 col-lg-3 pl-0 pr-0 pl-lg-3 pt-2 pt-lg-0">
								<div class="col-12 pl-0 pr-0 d-flex">
									<div class="col-6 pl-0 pr-2 pr-md-3">
										<button class="col-12 btn btn-sm btn-outline-danger rounded-cus no-box-focus" @click="reset"><span class="font-size-9">Reset</span></button>
									</div>
									<div class="col-6 pl-0 pr-0 pl-md-0 pr-md-3">
										<button class="col-12 btn btn-sm btn-blue rounded-cus no-box-focus" @click="cari"><span class="font-size-9">Cari</span></button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div  v-show="Object.values(mitraBaru).length == 0">
					<div class="col-12 pl-0 pr-0 mt-3 d-flex rounded-cus cus-box-shadow overflow-hidden" v-for="(index) in 3" :key="index">
						<div class="col-12 rounded-right-cus bg-white">
							<div class="col-12 pl-0 pr-0 pl-md-2 pr-md-2 pt-3 pb-3">
								<vcl :width='300' :height='35'>
									<rect x="0" y="0" rx="1" ry="1" width="4" height="4" />
									<rect x="7" y="0" rx="2" ry="2" width="55" height="4" />
									<rect x="250" y="0" rx="1" ry="1" width="50" height="80" />
									<rect x="0" y="9" rx="1" ry="1" width="4" height="4" />
									<rect x="7" y="9" rx="2" ry="2" width="25" height="4" />
									<rect x="62" y="9" rx="1" ry="1" width="4" height="4" />
									<rect x="69" y="9" rx="2" ry="2" width="20" height="4" />
									<rect x="123" y="9" rx="1" ry="1" width="4" height="4" />
									<rect x="130" y="9" rx="2" ry="2" width="28" height="4" />
									<rect x="186" y="9" rx="1" ry="1" width="4" height="4" />
									<rect x="194" y="9" rx="2" ry="2" width="17" height="4" />
									<rect x="7" y="15" rx="2" ry="2" width="20" height="5" />
									<rect x="69" y="15" rx="2" ry="2" width="33" height="4" />
									<rect x="194" y="15" rx="2" ry="2" width="14" height="4" />
									<rect x="0" y="25" rx="1" ry="1" width="4" height="4" />
									<rect x="7" y="25" rx="2" ry="2" width="25" height="4" />
									<rect x="7" y="31" rx="2" ry="2" width="52" height="4" />
								</vcl>
							</div>
						</div>
					</div>
				</div>
				<div v-if="mitraBaru == 'error'">
					<div class="col-12 pl-0 pt-3">
						<div class="col-12 pt-3 pb-3 bg-white rounded-cus cus-box-shadow">
							<div class="col-12 text-center">
								<div class="col-6 col-md-3 ml-auto mr-auto">
									<img class="img-fluid" src="/assets/report/ilustrasi-data-kosong-report.png">
								</div>
								<div class="font-size-11 pt-1">Data tidak tersedia!</div>
							</div>
						</div>
					</div>
				</div>
				<div  v-else>
					<div class="col-12 pl-0 pr-0 mt-3 d-flex flex-wrap rounded-cus cus-box-shadow overflow-hidden" v-for="(value, index) in mitraBaru" :key="index" :class="getClass(value.register_status)">
						<div class="col-12 col-md-10 rounded-left-cus rounded-right-cus bg-white">
							<div class="col-12 pl-0 pr-0 pl-md-2 pr-md-2 pt-3 pb-3">
								<div class="col-12 pl-0 pr-0 d-flex font-size-9">
									<span class="w-1rem"><i class="far fa-calendar-alt mt-auto mb-auto color-blue"></i></span>
									<div class="pl-2">Tanggal Transaksi : {{value.trx_datetime |tanggaljam}}</div>
								</div>
								<div class="col-12 pl-0 pr-0 d-flex flex-wrap">
									<div class="col-12 col-md-6 col-lg-3 pl-0 pr-0">
										<div class="col-12 pl-0 pr-0 pt-3 d-flex color-gray-2 font-size-10">
											<span class="w-1rem mt-auto mb-auto font-weight-bold">#</span>
											<div class="pl-2 font-size-9">Kode Sponsor</div>
										</div>
										<div class="pl-4 color-light-blue font-size-sm-10">{{value.register_sponsor_code}}</div>
									</div>
									<div class="col-12 col-md-6 col-lg-3 pl-0 pr-0">
										<div class="col-12 pl-0 pr-0 pt-3 d-flex color-gray-2 font-size-10">
											<span class="w-1rem"><i class="fas fa-user mt-auto mb-auto"></i></span>
											<div class="pl-2 font-size-9">Nama Mitra</div>
										</div>
										<div class="pl-4 color-black font-size-sm-10">{{value.register_member_name}}</div>
									</div>
									<div class="col-12 col-md-6 col-lg-3 pl-0 pr-0">
										<div class="col-12 pl-0 pr-0 pt-3 d-flex color-gray-2 font-size-10">
											<span class="w-1rem"><i class="fas fa-phone-alt mt-auto mb-auto"></i></span>
											<div class="pl-2 font-size-9">Nomor Handphone</div>
										</div>
										<div class="pl-4 color-black font-size-sm-10">{{value.register_member_phone}}</div>
									</div>
									<div class="col-12 col-md-6 col-lg-3 pl-0 pr-0">
										<div class="col-12 pl-0 pr-0 pt-3 d-flex color-gray-2 font-size-10">
											<span class="w-1rem"><i class="fas fa-upload mt-auto mb-auto"></i></span>
											<div class="pl-2 font-size-9">Platform</div>
										</div>
										<div class="pl-4 color-black font-size-sm-10">{{value.register_platform}}</div>
									</div>
									<div class="col-12 col-md-6 col-lg-3 pl-0 pr-0" v-if="false">
										<div class="col-12 pl-0 pr-0 pt-3 d-flex color-gray-2 font-size-10">
											<span class="w-1rem"><i class="fas fa-map-marker-alt mt-auto mb-auto"></i></span>
											<div class="pl-2 font-size-9">Area Mitra</div>
										</div>
										<div class="pl-4 color-black font-size-sm-10">{{value.register_member_province_name}}</div>
									</div>
								</div>
								<div class="col-12 pl-0 pr-0" v-if="false">
									<div class="col-12 pl-0 pr-0 pt-3 d-flex color-gray-2 font-size-10">
										<span class="w-1rem"><i class="fas fa-map-marked-alt mt-auto mb-auto"></i></span>
										<div class="pl-2 font-size-9">Alamat Mitra</div>
									</div>
									<div class="pl-4 font-size-sm-10">{{value.register_member_address}} {{value.register_member_city_name}} {{value.register_member_province_name}}</div>
								</div>
							</div>
						</div>
						<div class="col-12 col-md-2 pl-0 pr-0 pt-2 pb-2 pt-md-0 pb-md-0 d-flex">
							<div class="col-12 pl-1 pr-1 text-center mt-auto mb-auto color-white font-size-10">
								<div class="font-weight-bold pb-1 pb-md-2 text-capitalize">{{value.register_status}}</div>
								<div>
									<div v-if="value.register_status == 'pending'">Belum Terdaftar</div>
									<div v-if="value.register_status == 'waiting'">Belum mengisi form</div>
									<div v-if="value.register_status == 'registered'">Terdaftar {{value.register_api_mlm_datetime | toTanggal}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-12 pt-3 pl-0 pr-0 text-center">
					<i-pagination :limit = 'limit' @changeLimit="changeLimit($event)" :pagination = 'pagination' @gotoPage="gotoPage($event)" @refresh="refresh($event)"></i-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import IPagination from '@/components/IPagination.vue';
import { mapState, mapActions, mapGetters } from 'vuex';
import moment from 'moment'

export default {
	components: {
		IPagination
	},
	name: 'Report',
	data() {
		return {
			tfilter: false,
			today: new Date().toISOString(),
			pilihanSerial:'',
			tanggalAwal: "",
			tanggalAkhir: "",
			params: {},
			limit: 5,
			page : 1,
			status: [{
				text: "Waiting",
				value: 'waiting'
			}, {
				text: "Registered",
				value: 'registered'
			}, {
				text: "Pending",
				value: 'pending'
			}],
			nama:{
				value:'',
				comparison:'LIKE',
				type:'string',
				field:'register_member_name'
			},
			tanggal:{
				value:'',
				comparison:'bet',
				type:'date',
				field:'trx_datetime'
			},
			statusSerial: {
				value: '',
				comparison:'=',
				type:'string',
				field: 'register_status',
			},
		}
	},
	methods:{
		...mapActions('reportList', ['getMitraBaru']),
		getClass(val) {
			if(val == 'registered') {
				return 'bg-light-blue'
			} else if (val == 'waiting') {
				return 'bg-red'
			} else {
				return 'bg-gray-2';
			}
		},
		gotoPage(val) {
			this.page  = val
			if(this.params) {
				this.getMitraBaru({params:this.params, page: this.page, limit : this.limit})
			} else {
				this.getMitraBaru({page: this.page, limit : this.limit})
			}
		},
		refresh(val) {
			this.page  = val
			if(this.params) {
				this.getMitraBaru({params:this.params, page: this.page, limit : this.limit})
			} else {
				this.getMitraBaru({page: this.page, limit : this.limit})
			}
		},
		changeLimit(val) {
			this.page = 1
			this.limit  = val
			if(this.params) {
				this.getMitraBaru({params:this.params, page: this.page, limit : this.limit})
			} else {
				this.getMitraBaru({page: this.page, limit : this.limit})
			}
		},
		cari() {
			this.params = []
			this.page = 1
			if(!this.tanggalAkhir) {
				this.tanggalAkhir = this.tanggalAwal
			}
			if(this.tanggalAwal && this.tanggalAkhir) {
				this.tanggal.value = moment(this.tanggalAwal).format('YYYY-MM-DD')+"::"+moment(this.tanggalAkhir).format('YYYY-MM-DD')		
				this.params.push(this.tanggal)
			}
			if(this.nama.value) {
				this.params.push(this.nama)
			}
			if(this.pilihanSerial) {
				this.statusSerial.value = this.pilihanSerial.value
				this.params.push(this.statusSerial)
			}
			this.getMitraBaru({params:this.params, page: this.page, limit : this.limit})
		},
		reset() {
			this.statusSerial.value = ''
			this.pilihanSerial = ''
			this.nama.value = ''
			this.tanggal.value = ''
			this.tanggalAwal = ''
			this.tanggalAkhir = ''
			this.page  = 1
			this.limit = 5
			this.getMitraBaru({params : [], page: this.page, limit : this.limit})
		},
		toggleFilter() {
			if ( !this.tfilter ) {
				this.tfilter = true;
			} else {
				this.tfilter = false;
			}
		},
	},
	computed: {
		...mapState('reportList', ['mitraBaru', 'pagination']),
		...mapState('auth', ['userData']),
		...mapGetters('auth', ['isAuth']),
		minDate(){
			var date = new Date().toISOString()
			if (this.tanggalAwal) {
				date = new Date(this.tanggalAwal).toISOString()
			} else {
				date = new Date("2000-01-01").toISOString()
			}
			return date
		},
		maxDate(){
			var date = new Date().toISOString()
			if (this.tanggalAkhir) {
				date = new Date(this.tanggalAkhir).toISOString()
			}
			return date
		}
	},
	created () {
		this.$store.dispatch('setPageTitle', 'Laporan Mitra Baru');
		this.getMitraBaru({params : [], page: this.page, limit : this.limit})
	}
};
</script>
